<!--
 * @Author: klein
 * @Date: 2021-12-16 09:49:39
 * @Description:
 * @LastEditors: Klein
 * @LastEditTime: 2022-01-10 15:11:34
 * @FilePath: \planApp\src\components\Channel\index.vue
-->

<template>
  <div
    id="channel"
    :style="{width: dialogWidth}"
    v-loading="loading">
    <FreeTrial
      v-if="!hasSub && !querySubLoading"
      :planDetail="planDetail"></FreeTrial>
    <Manage
      v-if="hasSub && !querySubLoading"
      :planDetail="planDetail"
      :subscription="subscription"
      @titlechange ="(value) => $emit('titlechange', value)"
      @loadData="loadData"></Manage>
  </div>
</template>

<script>
import { GET_NAMES } from '../../queries'
import { userHasSubscription } from '../../common/checkuser'
import { mapState } from 'vuex'
import FreeTrial from './FreeTrial.vue'
import Manage from './Manage.vue'
export default {
  name: 'Channel',
  components: {
    FreeTrial,
    Manage
  },
  data () {
    return {
      planDetail: null,
      subscription: null,
      error: false,
      hasSub: true,
      plansLoading: true,
      querySubLoading: true,
      dialogWidth: '408px'
    }
  },
  apollo: {
    plans: {
      query: GET_NAMES,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      credentials: true,
      variables () {
        return {
          customerId: this.emailid,
          product: 'Tvuchannel'
        }
      },
      result ({ data, loading, error }) {
        if (data) {
          this.planDetail = data.plan.plans[0]
          // this.cycle = this.handlecycle(this.planDetail.chargeCycle)
          // this.price = JSON.parse(this.planDetail.metadata).price
          // this.day = this.planDetail.trialTime / 86400
          this.querySubStatus()
        }
        console.log(loading)
        this.plansLoading = loading
        this.error = error
      }
    }
  },
  methods: {
    // 查询订阅状态
    querySubStatus () {
      const params = {
        product: 'Tvuchannel',
        planId: this.planDetail.id
      }
      userHasSubscription(params).then(({ data, loading }) => {
        this.querySubLoading = loading
        const subPlans = data.subscription.subscriptions || []
        if (subPlans.length > 0) {
          // this.planisSub = subPlans.findIndex(i => i.planId === this.planDetail.id) > -1
          const item = subPlans.find(i => i.planId === this.planDetail.id)
          console.log(item)
          this.subscription = item

          //  0:订阅  1:订阅失败 2:cancel  3:试用
          // this.hasSub =  item.status == 3 || item.status == 0 || item.status == 2
          this.dialogWidth = '440px'
          this.hasSub = true
          this.$emit('titlechange', 'Manage Subscriptions')
        } else {
          this.dialogWidth = '408px'
          this.hasSub = false
          this.$emit('titlechange', 'Subscribe to TVU Channel Service')
        }
      })
    },
    loadData () {
      this.querySubStatus()
    }
  },
  computed: {
    ...mapState({
      emailid: state => state.userInfo.email
    }),
    loading () {
      return this.plansLoading || this.querySubLoading
    }
  }
}
</script>

<style lang="less" scoped>
  #channel {
    height: 100%;
    min-width: 240px;
    min-height: 300px;
    width: 408px;
  }
  // @media only screen and (min-width: 1200px) and (max-width: 1919px) {
  //   #channel {
  //     width: 408px;
  //   }
  // }

  // @media only screen and (min-width: 992px) and (max-width: 1199px) {
  //   #channel {
  //     width: 408px;

  //   }
  // }

  // @media only screen and (min-width: 768px) and (max-width: 991px) {
  //   #channel {
  //     width: 408px;

  //   }
  // }

  // @media only screen  and (max-width: 767px) {
  //   #channel {
  //     width: 408px;

  //   }
  // }
</style>
